import { HTTP_METHOD_POST } from '../../constants/httpMethod';
import { REQUEST_DISENROLLMENT, SUCCESS_DISENROLLMENT, FAILURE_DISENROLLMENT } from './constants';

import { CALL_API } from '../../middlewares/api';

export const ERROR_FORMDATA_EMPTY = 'formData param must not be empty or null or undefined !';

export function sendDisenrollmentRequest(callback) {
    return {
        [CALL_API]: {
            endpoint: '/user/disenroll',
            method: HTTP_METHOD_POST,
            types: [REQUEST_DISENROLLMENT, SUCCESS_DISENROLLMENT, FAILURE_DISENROLLMENT],
            successCallback: (response, dispatch) => {
                if (callback) {
                    callback();
                }
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/disenrollment/actions.js